import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-20 px-4" data-id="element-104">
      <div className="max-w-3xl mx-auto text-center" data-id="element-105">
        <div className="flex justify-center mb-6" data-id="element-106">
          <ShieldCheck className="w-20 h-20 text-solution" data-id="element-107" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-chocolate-900 mb-8" data-id="element-108">
          GARANTÍA TOTAL DE 7 DÍAS
        </h2>

        <div className="space-y-4 text-lg md:text-xl text-chocolate-800 leading-relaxed max-w-2xl mx-auto" data-id="element-109">
          <p data-id="element-110">
            Probá el Sistema completo. Hacé la primera receta. Aplicá el Ciclo
            Antídoto.
          </p>
          <p data-id="element-111">
            Si en 7 días no sentís la diferencia...{' '}
            <span className="font-bold text-chocolate-900" data-id="element-112">
              Te devolvemos el 100%.
            </span>
          </p>
          <p data-id="element-113">Sin formularios. Sin preguntas. Un mail es suficiente.</p>
          <p className="text-2xl font-bold text-solution mt-6 pt-4 border-t border-chocolate-100" data-id="element-114">
            Nuestro riesgo. Tu resultado.
          </p>
        </div>
      </div>
    </section>;
}